'use strict';

// 固件变更信息富文本编辑器配置（在默认工具栏基础上增加字号设置）
export default {
  toolbar: [
    ['style', ['style']],
    ['font', ['bold', 'underline', 'clear']],
    ['fontname', ['fontname']],
    ['fontsize', ['fontsize']],
    ['color', ['color']],
    ['para', ['ul', 'ol', 'paragraph']],
    ['table', ['table']],
    ['insert', ['link', 'picture', 'video']],
    ['view', ['fullscreen', 'codeview', 'help']]
  ],
  fontSizes: ['10', '12', '14', '16', '18', '20', '24', '28', '32', '36']
};



// WEBPACK FOOTER //
// ./client/app/firmwares/summernote.config.js